export default {
  'menu.account': '账号安全',
  'pages.account.action.changePassword': '修改密码',
  'pages.account.action.logout': '登出',
  'pages.account.action.refresh': '刷新',
  'pages.account.action.register': '注册',
  'pages.account.currentAdmin': '当前管理员',
  'pages.account.field.confirmPassword': '确认密码',
  'pages.account.field.password': '密码',
  'pages.account.field.username': '用户名',
  'pages.account.logout.confirm': '确认登出当前账号？',
  'pages.account.message.saved': '操作成功',
  'pages.account.password.title': '修改密码',
  'pages.account.register.title': '注册管理员',
  'pages.account.title': '账号安全',
  'pages.account.validation.confirmRequired': '请确认密码',
  'pages.account.validation.passwordMismatch': '两次输入的密码不一致',
  'pages.account.validation.passwordRequired': '请输入密码',
  'pages.account.validation.passwordStrong':
    '密码至少 8 位，需包含大写字母、小写字母、数字和特殊字符，且不能包含空格',
  'pages.account.validation.usernameRequired': '请输入用户名',
};
